import React from "react";
import { CustomFlowbiteTheme, Modal } from "flowbite-react";
import { FaCircleCheck } from 'react-icons/fa6'
import { useModal } from "../../../../hooks/ModalContext";
import { QueueProps, useFila } from "../../../../context/FilaContext";
import { useClear } from "../../../../hooks/useClear";
import { useHistorico } from "../../../../context/HistoricoContext";
import { useDividas } from "../../../../context/DividasContext";
import { useChatWhatsApp } from "../../../../context/ChatWhatsAppContext";
import { useAuth } from "../../../../context/AuthContext";
import { useQueryClient } from "@tanstack/react-query";
import { useContrato } from "../../../../context/ContratoContext";
import { usePropostas } from "../../../../context/PropostasContext";
import { useNeg } from "../../../../context/NegContext";
import { useBoleto } from "../../../../context/BoletoContext";
import { useOperador } from "../../../../context/OperadorContext";
import { ConsultaAcordoResponse } from "../../../../types/consulta-acordo-interface";

interface ModalTabFinalizarProps {
  message?: string;
  img?: string;
  isOperador?: boolean
  app?: string
}

export const ModalTabFinalizar = ({ message, img, isOperador, app }: ModalTabFinalizarProps) => {
  const { onClose, openTabFinModal, setModal } = useModal()
  const { getContracts } = useContrato();
  const { getSelectedProposta, getPropostas } = usePropostas();
  const { clearParcelasNeg } = useNeg()
  const { endQueue, devedorFilaSelected, getChatId, getDevedorFilaSelected, fila, clearSelectedFila } = useFila()
  const { selectedCredor, devedor } = useDividas()
  const { getHistorico } = useHistorico()
  const { clearBoleto } = useBoleto()
  const { clearData } = useClear()
  const { chatIdHibrido, endChat } = useChatWhatsApp()
  const { cookies } = useAuth()
  const { setTab } = useOperador()
  const { setSelectedAcordoResponse } = useNeg()
  const queryClient = useQueryClient()
  const appWS = app ? app : isOperador ? 'ACIONA_OPE' : 'ACIONA_WEB'

  const themeModal: CustomFlowbiteTheme['modal'] = {
    root: {
      base: 'fixed top-0 right-0 left-0 z-40 h-modal h-screen overflow-y-auto overflow-x-hidden md:inset-0 md:h-full'
    }
  }
  async function handleEndChatHibrido() {
    const id_chat = chatIdHibrido || '';
    const token = cookies?.whatsapp?.token || '';
    await endChat(id_chat, token);
  }

  async function handleEndChat() {
    const id_chat = devedorFilaSelected.id_chat || ''
    const token = cookies?.whatsapp?.token || ''
    await endChat(id_chat, token)
    await getChatId(Number(devedorFilaSelected.id_queue), '')
    await queryClient.refetchQueries({ queryKey: ['atendimento'] })
    if (fila && devedorFilaSelected?.cpf_cnpj) {
      getDevedorFilaSelected(fila.find(item => item.cpf_cnpj === devedorFilaSelected?.cpf_cnpj) || {} as QueueProps)
    }
  }

  async function closeModal() {
    onClose()
    clearParcelasNeg()
    getSelectedProposta()
    clearBoleto()
    setSelectedAcordoResponse({} as ConsultaAcordoResponse)
    if (!isOperador) {
      await getPropostas({ codcredor: String(selectedCredor.credor_crm), cpf_cnpj: devedor.cpf_cnpj, url: selectedCredor.url_ws },)
    }
    await getContracts({ credor: selectedCredor.credor_crm, cpf_cnpj: devedor.cpf_cnpj, url: selectedCredor.url_ws, app: appWS })
    await getHistorico({ codcredor: String(selectedCredor.credor_crm), cpf_cnpj: devedor.cpf_cnpj, url: selectedCredor.url_ws, app: appWS })
  }

  function end() {
    clearData()
    onClose()
    setModal("Atendimento finalizado com sucesso", "Sucesso", true, false);
  }

  async function finalizarAtendimento() {
    if (isOperador) {
      setTab('fila-cobranca')
      clearData()
      onClose()
      return
    }


    if (chatIdHibrido) {
      await handleEndChatHibrido();
    }

    if (devedorFilaSelected.id_chat) {
      await handleEndChat()
      await endQueue(devedorFilaSelected.id_queue)
      clearSelectedFila()
    }

    if (!devedorFilaSelected.id_chat && devedorFilaSelected?.cpf_cnpj) {
      await endQueue(devedorFilaSelected.id_queue)
      clearSelectedFila()
    }

    end()
    // if (fila?.length > 0) {
    //   setModal("Proximo Atendimento", "Atendimento");
    // }

  }
  return (
    <>
      <Modal
        show={openTabFinModal.isOpen}
        popup={true}
        size={"lg"}
        onClick={() => onClose()}
        theme={themeModal}
      >
        <Modal.Body>
          <div className="flex items-center justify-center flex-col p-4">
            {img ? <img src={img} alt="" /> : <FaCircleCheck className="fill-green-600 m-4" size={70} />}
            <p className="font-medium text-center text-lg m-2 text-gray-800 w-full">{message ? message : openTabFinModal.title}</p>
            <div className="flex items-center gap-4 text-sm w-full">
              <button type="button" className="bg-primary text-white px-4 py-2 rounded-md mt-4 w-full" onClick={() => closeModal()}>Continuar atendimento</button>
              <button type="button" className="bg-error text-white px-4 py-2 rounded-md mt-4 w-full" onClick={() => finalizarAtendimento()}>Finalizar atendimento</button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  )
}